<template>
  <div>
    channels
  </div>
</template>

<script>
  export default {
    name: 'Channels',
    routeConfig: {
      name: "channels", path: "/channels"
    },
    metaInfo: {
      title: "Channels"
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/routes/Channels/index.vue